import {
    Button,
    createButton,
    IButtonBusinessLogic,
} from '@vfde-brix/ws10/button';

/**
 * Returns a Button ws10 class mounted on the chosen div and if provided with an onClick event without a return value.
 */
export const mountButton = (wrapperId: string, onClick?: () => void): Button | null => {
    const wrapperElement = document.getElementById(wrapperId);
    const business: IButtonBusinessLogic = {
        onClick,
    };

    return wrapperElement && createButton(wrapperElement, business);
};
